import React, { useState } from 'react';
import { Button, Divider, Flex, Text } from '@homeexchange/design';
import Utils from '../../../utils/utils';
import Analytics from '../../../utils/analytics';
import styles from './noResults.module.scss';
import i18n from '../../../i18n';
import { SavedSearchModal } from './savedSearchModal';
export function NoResults(_a) {
    var onExpandSearchArea = _a.onExpandSearchArea, user = _a.user, locationQuery = _a.locationQuery, filtersWithoutLuxury = _a.filtersWithoutLuxury, onPushAlert = _a.onPushAlert;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = useState(false), isCreatingAlert = _c[0], setIsCreatingAlert = _c[1];
    var _d = useState(null), createdAlert = _d[0], setCreatedAlert = _d[1];
    var handleExpandSearchArea = function () {
        if (onExpandSearchArea) {
            onExpandSearchArea(1.5);
        }
    };
    var userCollection = user === null || user === void 0 ? void 0 : user.isCollection();
    var handleCreateAlert = function () {
        Analytics.trackGTM('SearchResults', {
            event_data: {
                action: 'click',
                area: 'search',
                text: 'save_this_destination',
                origin: 'no_results',
                search_value: locationQuery
            }
        });
        setIsCreatingAlert(true);
        onPushAlert()
            .then(function (result) {
            setIsCreatingAlert(false);
            setIsOpen(true);
            setCreatedAlert(result);
        })
            .catch(function (error) {
            console.error('Failed to create alert:', error);
            setIsCreatingAlert(false);
        });
    };
    return (React.createElement("div", { className: styles['no-results'] },
        React.createElement(Text, { isBold: true, size: "lg", className: styles['no-results-title'] }, i18n.t('search:page.search.noResults.title')),
        React.createElement("div", { className: styles['no-results-content'] },
            React.createElement("div", null,
                React.createElement(Text, { isBold: true }, i18n.t('search:page.search.noResults.expand.title')),
                React.createElement(Text, { isSmall: true }, i18n.t('search:page.search.noResults.expand.body'))),
            React.createElement(Button, { className: styles['no-results-button'], color: "tertiary", onClick: handleExpandSearchArea }, i18n.t('search:no-results.expand-search-text'))),
        userCollection && filtersWithoutLuxury && (React.createElement(React.Fragment, null,
            React.createElement(Divider, { space: "small" }),
            React.createElement("div", { className: styles['no-results-content'] },
                React.createElement("div", null,
                    React.createElement(Text, { isBold: true }, i18n.t('search:no-results.check-non-collection-homes.title')),
                    React.createElement(Text, { isSmall: true }, i18n.t('search:no-results.check-non-collection-homes.text'))),
                React.createElement(Button, { color: "tertiary", onClick: function () { return filtersWithoutLuxury('luxury'); } }, i18n.t('search:no-results.check-non-collection-homes.button'))))),
        onPushAlert && (React.createElement(React.Fragment, null,
            React.createElement(Divider, { space: "small" }),
            React.createElement("div", { className: styles['no-results-content'] },
                React.createElement("div", null,
                    React.createElement(Text, { isBold: true }, i18n.t('user:banner_saveSearch_title')),
                    React.createElement(Text, { isSmall: true }, i18n.t('user:banner_saveSearch_desc', {
                        fullLocation: locationQuery
                    }))),
                React.createElement(Button, { color: "tertiary", onClick: handleCreateAlert, isLoading: isCreatingAlert }, i18n.t('search:alert.save_alert'))))),
        React.createElement(SavedSearchModal, { isOpen: isOpen, onClose: function () { return setIsOpen(false); }, createdAlert: createdAlert }),
        React.createElement(Divider, { space: "small" }),
        React.createElement(Flex, { justifyContent: "center", className: styles['no-results-image'] },
            React.createElement("img", { src: "".concat(Utils.getCloudfrontDomain(), "/images/website/migration/search/no-results").concat(userCollection ? '-collection' : '', ".svg"), alt: "No results" }))));
}
